<div class="d-flex flex-column gap-3 px-3">
  <div class="title-header pb-0 gap-4">
    <div class="d-flex align-items-center w-100 p-0 gap-3 search-bar">
      <div class="input-group align-items-center border div-search bg-white">
        <button type="button" class="border-0 bg-transparent p-0" aria-label="Tìm kiếm đơn hàng">
          <i class="ri-search-line d-flex justify-content-center align-items-center search-icon"></i>
        </button>
        <input #inputSearch id="quickSearchInput" type="search"
          class="form-control border-0 bg-transparent search-input" [placeholder]="'Nhập ' + selectedSearchOption.name.toLowerCase()"
          [(ngModel)]="inputText" (keyup.enter)="search(inputSearch.value)" />
        <div class="search-divider"></div>
        <div class="search-criteria">
          <button type="button" class="search-criteria-trigger" [attr.aria-expanded]="isSearchMenuOpen"
            aria-haspopup="listbox" (click)="isSearchMenuOpen = !isSearchMenuOpen">
            <span>{{ selectedSearchOption.name }}</span>
            <i class="ri-arrow-down-s-line" aria-hidden="true"></i>
          </button>
          <div class="search-criteria-menu" role="listbox" *ngIf="isSearchMenuOpen">
            <button type="button" role="option" *ngFor="let option of searchOptions"
              [attr.aria-selected]="selectedSearchOption.key === option.key"
              (click)="selectSearchOption(option)">
              <span>{{ option.name }}</span>
              <i class="ri-check-line" *ngIf="selectedSearchOption.key === option.key" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <app-date-range
        *ngIf="selectedSearchOption.key === 'lot'"
        [from]="fromDate"
        [to]="toDate"
        (fromChange)="fromDate = $event" (toChange)="toDate = $event"
        [placeholder]="selectedSearchOption.key === 'lot' ? 'Chọn ngày hết hạn SP' : 'Chọn ngày'"
      >
      </app-date-range>
      <button type="button" class="search-btn" (click)="search(inputSearch.value)">
        <i class="ri-search-line d-flex align-items-center fs-4" aria-hidden="true"></i>
        <span style="font-weight: 500;">Tìm kiếm</span>
      </button>
    </div>
    <div class="d-flex align-items-center w-100 gap-2 overflow-auto">
      <button *ngFor="let btn of filters" class="div-tag pe-3 ps-3 pt-2 pb-2 mb-1"
        [class]="btn.active ? 'active' : ''" (click)="filter(btn)">
        <h6 class="w-max-content">{{ btn.name }} ({{ btn.value }})</h6>
      </button>
    </div>
  </div>
  <ng-container *ngIf="orders.length">
    <div class="total-box mt-0 py-4 px-3 bg-white rounded-4">
      <div class="wallet-table mt-0 p-0">
        <div class="d-flex flex-column order-card">
          <ng-container *ngFor="let order of orders; let last = last">
            <app-order-card [order]="order"></app-order-card>
            <div *ngIf="order.childOrders?.length" class="child-order d-flex flex-column gap-3">
              <div class="child-order-caption d-flex align-items-center gap-1">
                <img src="assets/svg/order/child-order.svg" width="16" height="16" />
                <span>Đơn hàng đã tách</span>
              </div>
              <app-order-card *ngFor="let childOrder of order.childOrders; let i = index" [order]="childOrder" [isChildOrder]="true" [orderNumber]="i + 1"></app-order-card>
            </div>
            <div *ngIf="!last" style="background: #e5e7eb; height: 1px; width: 100%;"></div>
          </ng-container>
        </div>
      </div>
    </div>
    <nav class="custome-pagination">
      <app-collection-paginate> </app-collection-paginate>
    </nav>
  </ng-container>
  <ng-container *ngIf="!orders.length && skeletonLoader">
    <div class="d-block">
      <div class="skeleton-div">
        <div class="product-box skeleton-box bg-transparent">
          <div class="skeleton">
            <div class="skeleton__p w-100"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <app-no-data [class]="'no-data-added'" [image]="'assets/svg/empty-items.svg'" [text]="'Bạn chưa có đơn hàng nào!'"
    [description]="'Hãy đặt hàng ngay nhé!'" *ngIf="!orders.length && !skeletonLoader">
  </app-no-data>
</div>